export default __webpack_public_path__ + "static/media/visby-cf-medium.91fe964c.ttf";